/**
 * 로컬스토리지에 key:value로 저장
 *
 * 상세 설명은 cms-cacheable-fetch.md 파일 참조
 */
define(['api-request'], function (apiRequest) {
    var CACHE_NA = 0;

    var CACHE_AGED = 1;
    var CACHE_VALID = 2;
    var CACHE_BYPASS = 3;

    var CACHE_EXPIRE_SECS = 30 * 60;
    var TEMPLATE_CACHE_EXPIRE_SECS = 7 * 24 * 60 * 60; //7일

    /**
     * TODO constructor 로 변경
     */
    return function (page, is_refresh, at_time, is_local_refreh) {
        var fetcher = {
            page      : page,
            is_refresh: is_refresh,
            at_time   : at_time,
            is_local_refreh : is_local_refreh,

            // X분이 지난 로컬스토리지 데이터를 삭제한다.
            // 아이폰 로컬스토리지 허용 용량이 작아서 시간이 지난 데이터를 삭제해야함.
            fetch                  : function () {
                var _this = this;

                return new Promise(function (resolve, reject) {
                    switch (_this.cachedState())
                    {
                        case CACHE_BYPASS:
                            // resolve 될때까지 사실상 foreground(blocking) 작업
                            return _this.fetchApi()
                                .then(function (resp) {
                                    _this.cacheTemplates(resp.templates);
                                    resolve([resp.data, 0]);
                                })
                                .catch(function (error) {
                                    reject(error);
                                });

                        case CACHE_VALID:
                            return resolve(_this.cachedDataParsedWithTimestamp());

                        case CACHE_AGED:
                            resolve(_this.cachedDataParsedWithTimestamp());
                            // background 작업
                            _this.fetchApiThenCreateCache();
                            return;

                        case CACHE_NA:
                            // resolve 될때까지 사실상 foreground(blocking) 작업
                            return _this.fetchApiThenCreateCache()
                                .then(function (resp) {
                                    resolve(resp);
                                })
                                .catch(function (error) {
                                    reject(error);
                                });
                    }
                });
            },
            fetchApiThenCreateCache: function () {
                var _this = this;
                return new Promise(function (resolve, reject) {
                    _this.fetchApi()
                        .then(function (resp) {
                            _this.cacheTemplates(resp.templates);
                            resolve(_this.createCache(resp.data));
                        })
                        .catch(function (error) {
                            reject(error);
                        });
                });
            },
            fetchApi               : function () {
                var cached_templates = this.cachedTemplates();
                var cached_template_versions = Object.keys(cached_templates).map(function (template) {
                    return cached_templates[template].name + ":" + cached_templates[template].version;
                });
                console.log("fetchApi(); page:"+this.page+", at_time: " + this.at_time + ", refresh: "+this.is_refresh + ", local_refresh: "+this.is_local_refreh);
                return apiRequest.post("https://cus7.cconmausa.com/api/cms/fetch-pages/" + this.page, {at_time: this.at_time, refresh: this.is_refresh, lt: cached_template_versions});
            },
            createCache            : function (resp) {
                var cached_ts = Math.floor(Date.now() / 1000);
                try
                {
                    window.localStorage.setItem(this.cacheTimeKey(), String(cached_ts));
                    window.localStorage.setItem(this.cacheDataKey(), JSON.stringify(resp));
                }
                catch (e)
                {
                    window.localStorage.removeItem(this.cacheTimeKey());
                    window.localStorage.removeItem(this.cacheDataKey());
                }
                return [resp, cached_ts];
            },
            /*
                * Cache lifetime:
                *
                * |    ~1min    | ~ CACHE_EXPIRE_SECS     | CACHE_EXPIRE_SECS ~  |
                * |-------------|-------------------------|----------------------|
                * |  use cached |  use cached, fetch bg   |       fetch fg       |
                *
                */

            cachedState       : function () {
                if (this.at_time)
                {
                    return CACHE_BYPASS;
                }
                if (this.is_refresh)
                {
                    return CACHE_BYPASS;
                }
                //테스트를 위한 임시 조건 by sonbohoon(25-06-02)
                if (this.is_local_refreh)
                {
                    return CACHE_BYPASS;
                }
                // Case 1 of 3: 캐시 없음 또는 만료
                var cached_data_age_secs = this.cacheAgeSecs();

                // 더이상 사용 안하는 기준: 30분
                // 키가 없을 경우 cached_data_age_secs = CACHE_EXPIRE_SECS + 1
                if (cached_data_age_secs > CACHE_EXPIRE_SECS || this.cachedDataRaw() === null)
                {
                    return CACHE_NA;
                }

                // 섹션중에 캐시되지 않은 템플릿이 한개라도 있으면 캐시갱신
                if (!this.isCachedAllSectionsTemplate())
                {
                    return CACHE_NA;
                }

                // Case 2 of 3: 보유한 캐시가 소프트 만료됨. 일단 사용하고 백그라운드에서 캐시 갱신
                if (cached_data_age_secs > 60)
                {
                    return CACHE_AGED;
                }

                // Case 3 of 3: 캐시 소프트 만료 전
                return CACHE_VALID;
            },
            isCached          : function () {
                return this.cachedState() >= CACHE_AGED;
            },
            cacheTimeKey      : function () {
                return "cms-time" + ":" + this.page;
            },
            cacheDataKey      : function () {
                return "cms-data" + ":" + this.page;
            },
            cachedTimestamp   : function () {
                return parseInt(window.localStorage.getItem(this.cacheTimeKey()));
            },
            removeExpiredCache: function () {
                var now_ts = Math.floor(Date.now() / 1000);
                for (let i = 0; i < localStorage.length; i++)
                {
                    const key = localStorage.key(i);
                    if (key.indexOf('cms-time:') < 0)
                    {
                        continue;
                    }

                    var cached_timestamp = window.localStorage.getItem(key);
                    if ((now_ts - cached_timestamp) > CACHE_EXPIRE_SECS)
                    {
                        window.localStorage.removeItem(key);
                        var data_key = key.replace('cms-time', 'cms-data');
                        window.localStorage.removeItem(data_key);
                    }
                }

                // 이하 오랜기간 사용되지 않은 템플릿을 캐시에서 제거
                // 주의 : 템플릿 캐시는 'cms-templates' key 아래 저장됨.
                var cached_templates = this.cachedTemplates();

                for (var template in cached_templates)
                {
                    if (!cached_templates[template].used_ts
                        || (now_ts - cached_templates[template].used_ts) > TEMPLATE_CACHE_EXPIRE_SECS)
                    {
                        delete cached_templates[template];
                    }
                }
                try
                {
                    window.localStorage.setItem('cms-templates', JSON.stringify(cached_templates));
                }
                catch (e)
                {
                    window.localStorage.removeItem('cms-templates');
                }

            },
            /**
             *
             * @returns {number} 키가 없으면 CACHE_EXPIRE_SECS + 1 반환
             */
            cacheAgeSecs: function () {
                var cache_age_secs = CACHE_EXPIRE_SECS + 1;
                var cached_time = this.cachedTimestamp();
                if (!isNaN(cached_time) && cached_time !== null)
                {
                    cache_age_secs = Math.floor(Date.now() / 1000) - cached_time;
                }

                return cache_age_secs;
            },

            cachedDataRaw: function () {
                return window.localStorage.getItem(this.cacheDataKey());
            },

            cachedDataParsedWithTimestamp: function () {
                return [JSON.parse(this.cachedDataRaw()), this.cachedTimestamp()];
            },

            /**
             * 캐시된 모든 템플릿 리턴
             * @returns {any}
             */
            cachedTemplates: function () {
                return window.localStorage.getItem('cms-templates') ? JSON.parse(window.localStorage.getItem('cms-templates')) : {};
            },

            /**
             * 캐시된 템플릿중 템플릿 이름 일치하는 템플릿 리턴
             * @param template_name
             * @returns {undefined|*}
             */
            cachedTemplate: function (template_name) {
                if (!this.hasCachedTemplate(template_name))
                {
                    return undefined;
                }

                return this.cachedTemplates()[template_name];
            },

            /**
             * 템플릿이 로컬스토리지에 저장되어 있는지 여부
             * @param {string} template_name
             * @return {boolean}
             */
            hasCachedTemplate: function (template_name) {
                var cached_templates = this.cachedTemplates();
                return cached_templates.hasOwnProperty(template_name);
            },

            /**
             * 모든 섹션의 템플릿이 캐시되어 있는지 여부
             * @returns {boolean}
             */
            isCachedAllSectionsTemplate: function () {
                var data = JSON.parse(this.cachedDataRaw());

                for (var i = 0; i < data.sections.length; i++)
                {
                    var section = data.sections[i];
                    if (!this.hasCachedTemplate(section.template))
                    {
                        return false;
                    }
                }
                return true;
            },

            /**
             * 템플릿 한개를 로컬스토리지에 캐시
             * @param {Object} template {name:'', path:'', version:'', html:''}
             * @return {boolean}
             */
            cacheTemplate: function (template) {
                var cached_templates = this.cachedTemplates();

                cached_templates[template.name] = template;
                try
                {
                    window.localStorage.setItem('cms-templates', JSON.stringify(cached_templates));
                }
                catch (e)
                {
                    window.localStorage.removeItem('cms-templates');
                }
                this.updateTemplateUsedTs(template.name);
                return true;
            },

            /**
             * 여러 템플릿을 로컬스토리지에 캐시
             * @param {Object} templates [{name:'', path:'', version:'', html:''},...}
             */
            cacheTemplates: function (templates) {
                var _this = this;
                templates.forEach(function (template) {
                    _this.cacheTemplate(template);
                })
            },
            /**
             * 템플릿 사용일시 업데이트
             * 사용일시 목적 : 오랜기간 사용되지 않은 템플릿을 캐시에서 제거하기 위함
             * @param {string} template_name
             */
            updateTemplateUsedTs: function (template_name) {
                var template = this.cachedTemplate(template_name);
                if (typeof template === 'undefined')
                {
                    return;
                }
                template.used_ts = Math.floor(Date.now() / 1000);
                var cached_templates = this.cachedTemplates();
                cached_templates[template_name] = template;

                try
                {
                    window.localStorage.setItem('cms-templates', JSON.stringify(cached_templates));
                }
                catch (e)
                {
                    window.localStorage.removeItem('cms-templates');
                }
            },

            /**

             */
            /**
             * 섹션의 모든 템플릿 사용일시 업데이트
             * 사용일시 목적 : 오랜기간 사용되지 않은 템플릿을 캐시에서 제거하기 위함
             *
             * @param {Array} sections
             */
            updateSectionsTemplateUsedTs: function (sections) {
                var _this = this;
                sections.forEach(function (section) {
                    _this.updateTemplateUsedTs(section.template);
                });
            }
        }

        fetcher.removeExpiredCache();

        return fetcher;
    }
})
